/**
 * WORKS詳細
 */
import 'es6-promise/auto';
import 'picturefill';
import 'lazysizes';
import { breakpoint, containerID } from '@/_modules/utils/variables';
// vue
import Vue from 'vue';
import store from '@/_modules/stores';
import Loading from '@/_components/loading.vue';
import TransitionCover from '@/_components/transition-cover.vue';
import GlobalHeader from '@/_components/global-header.vue';
import GlobalFooter from '@/_components/global-footer.vue';
import GlobalNavi from '@/_components/global-navi.vue';
import EntryMv from '@/_components/entry-mv.vue';
import Carousel from '@/_components/carousel.vue';
import Related from '@/_components/related.vue';
import RelatedSp from '@/_components/related-sp.vue';
import CommonPlugin from '@/_modules/common/common-plugin'
Vue.use(CommonPlugin);

import scrollManager from '@/_modules/common/scrollManager';
import subBg from '@/_modules/common/subBg';
window.$scrollManager = scrollManager;

export default class AppWorksEntry {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'AppWorksEntry';
    this.init();
  }

  /**
   * 初期
   */
  init() {
    new subBg();

    this.vue = new Vue({
      components: {
        Loading,
        TransitionCover,
        GlobalHeader,
        GlobalFooter,
        GlobalNavi,
        EntryMv,
        Carousel,
        Related,
        RelatedSp
      },
      data() {
        return {
          ispc: false,
          isLoaded: false,
          isState: '',
          wrapStyle: '',
          vPlayer: null,
          vType: null,
          ticker: [],
        }
      },
      el: `#${containerID}`,
      store,
      computed: {
      },
      created() {
        this.$store.commit('setDevice');
      },
      mounted() {
        $scrollManager.init();

        this.$nextTick(this.start);
      },
      methods: {
        start() {
          this.settingVideo();

          this.$store.commit('setShowCoverOut', false);
        },
        // 動画
        settingVideo() {
          const wrap = this.$refs['p-worksEntry__vWrap'];
          if (wrap) {
            const iframe = wrap.querySelector('iframe');
            iframe.src = iframe.getAttribute('data-src');

            if (iframe.src.indexOf('youtube.com') > -1) {
              this.vType = 'youtube';
              // Youtube API読み込み
              let tag = document.createElement('script');
              tag.src = "//www.youtube.com/iframe_api";
              let firstScriptTag = document.getElementsByTagName('script')[0];
              firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

              // API読み込み後にプレーヤーの設定
              window.onYouTubeIframeAPIReady = this.readyVideo;
            } else if (iframe.src.indexOf('vimeo.com') > -1) {
              this.vType = 'vimeo';
              this.readyVideo();
            }

            const paddingTop = (iframe.getAttribute('height') / iframe.getAttribute('width')) * 100;
            this.wrapStyle = `padding-top:${paddingTop}%`;
          }
        },
        readyVideo() {
          if (this.vType === 'youtube') {
            this.vPlayer = new YT.Player('p-worksEntry__video');
          } else if (this.vType === 'vimeo') {
            this.vPlayer = new Vimeo.Player(document.getElementById('p-worksEntry__video'));
          }
        },
        playVideo(e) {
          this.$refs['p-worksEntry__vWrap__cover'].style.display = 'none';

          // 再生
          if (this.vType === 'youtube') {
            this.vPlayer.playVideo();
          } else if (this.vType === 'vimeo') {
            this.vPlayer.play();
          }
        },
        showLoading() {
          this.$store.commit('setShowLoading', true);
        },
        hideLoading() {
          this.$store.commit('setShowLoading', false);
        }
      }
    });
  }
}
